import { ReactElement, ReactNode } from 'react';

interface GridContentProps {
  children: ReactNode;
  className?: string;
  spanCount?: number;
}

export default function GridContent({ children, spanCount, className = '' }: GridContentProps): ReactElement {
  return (
    <div
      className={`cr-col-span-${spanCount} cr-grid cr-grid-cols-subgrid 
                  cr-rounded-b-lg cr-border-2 cr-border-t-0 cr-border-solid cr-border-cirrusBlue-100 
                  cr-bg-cirrusBlue-25 cr-pb-6
                  cr-font-main cr-text-[12px] md:cr-text-[14px] ${className}`}
    >
      {children}
    </div>
  );
}
